<template>
  <div class="content">
    <img class="img" :src="public_path + '/static/images/publicity.png'" alt="">
    <div class="btn">
      <button @click="publicity">我要申请</button>
      <button @click="logout" class="sigin-out">我要退出</button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    },
    publicity () {
      this.$router.push({
        path: '/apply'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  padding-bottom: 2rem;
}
.img {
  width: 100%;
  height: auto;
}
.btn {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: .1rem .3rem;
  box-sizing: border-box;
  font-size: 0;
  button {
    display: inline-block;
    width: 100%;
    font-size: .28rem;
    height: .8rem;
    line-height: .8rem;
    background: #000;
    color: #fff;
  }
  .sigin-out {
    background: #fff;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publicity/publicity.vue